import i18next from 'i18next';
import { useEffect, useMemo, useState } from 'react';

import { TranslationKeys } from '@ui-core/types';
import { LanguageItems } from '@type';
import { changeLanguage } from '@utils';

const useAuthFooterService = () => {
  const [selectedLanguage, setSelectedLanguage] = useState(
    i18next.resolvedLanguage ?? navigator.language
  );

  const languageList = useMemo(() => {
    return Object.entries(LanguageItems).map(([key, value]) => {
      const languageKey = key as keyof typeof LanguageItems;
      return {
        key: value.code,
        labelKey: `languages.${languageKey.toLowerCase()}` as TranslationKeys,
      };
    });
  }, []);

  useEffect(() => {
    if (selectedLanguage) changeLanguage(selectedLanguage);
  }, [selectedLanguage]);

  return {
    selectedLanguage,
    setSelectedLanguage,
    languageList,
  };
};
export default useAuthFooterService;
